import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
export const PageHeading = content => {
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    direction: "vertical",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    textAlign: "center"
  }, content.title), /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, content.subtitle));
};
//# sourceMappingURL=PageHeading.js.map